<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlayPanelClass="nimbus-filter-select-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (detach)="onDetach()"
  (attach)="onAttach(overlay)"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div #filterOverlay class="nimbus-tooltip-complex flex-container tooltip-content nimbus-filter-select-list-container">
    <nimbus-nimbus-filter-select-list
      [options]="filter.options"
      [searchable]="filter.searchable"
      [focusable]="false"
      [selectedOptions]="filterValue"
      (selectionChanged)="onSelectionChanged($event)"
      (searchControlValueChanged)="onSearchControlValueChanged($event)"
    ></nimbus-nimbus-filter-select-list>
  </div>
</ng-template>
